import { Pipe, PipeTransform } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { addClass, removeClass } from '../../../../../utils/toggle-class/toggle-class';
import compareAsc from 'date-fns/compareAsc';
import format from 'date-fns/format';
import startOfDay from 'date-fns/startOfDay';
import { IDate } from '../../../../../core/interfaces/datepicker-date';
import lastDayOfMonth from 'date-fns/lastDayOfMonth';
import getDate from 'date-fns/getDate';

const isAfterExtensionDate = (availabilityDate: string, extensionToDate: string) =>
  !!extensionToDate &&
  compareAsc(startOfDay(new Date(availabilityDate + 'T00:00')), startOfDay(new Date(extensionToDate + 'T00:00'))) === 1;

@Pipe({
  name: 'formatDay',
  standalone: false
})
export class FormatDayPipe implements PipeTransform {
  transform(
    value: number,
    date: NgbDate,
    availabilityArray: any,
    day: HTMLElement,
    fromDate: IDate,
    toDate: IDate,
    extensionToDate?: string
  ): any {
    const defaultOutputValue = value;

    day.parentElement.removeAttribute('disabled');
    removeClass('date-disabled', day);
    removeClass('ngb-dp-day--last-day', day.parentElement);

    if (!availabilityArray) {
      return value;
    }

    if (getDate(lastDayOfMonth(startOfDay(new Date(date.year, date.month - 1, date.day)))) == date.day) {
      addClass('ngb-dp-day--last-day', day.parentElement);
    }

    let availabilityArrayPayload = availabilityArray[format(new Date(date.year, date.month - 1, date.day), 'yyyy-MM')];

    if (!availabilityArrayPayload?.length) {
      return value;
    }

    const isBeforeToday =
      compareAsc(startOfDay(new Date(date.year, date.month - 1, date.day)), startOfDay(new Date())) === -1;

    if (isBeforeToday) {
      return value;
    }

    for (let i = 0; i <= availabilityArrayPayload.length - 1; i++) {
      const isSameDay =
        compareAsc(
          startOfDay(new Date(date.year, date.month - 1, date.day)),
          startOfDay(new Date(availabilityArrayPayload[i].date + 'T00:00'))
        ) === 0;

      if (!isSameDay) {
        continue;
      }

      if (
        (!availabilityArrayPayload[i].isBookable && i !== 0 && !availabilityArrayPayload[i - 1].isBookable) ||
        (!availabilityArrayPayload[i].isBookable && i === 0) ||
        (!availabilityArrayPayload[i].isBookable &&
          i !== 0 &&
          toDate &&
          compareAsc(
            startOfDay(new Date(availabilityArrayPayload[i].date + 'T00:00')),
            startOfDay(new Date(toDate.year, toDate.month - 1, toDate.day))
          ) === -1 &&
          compareAsc(
            startOfDay(new Date(availabilityArrayPayload[i].date + 'T00:00')),
            startOfDay(new Date(fromDate.year, fromDate.month - 1, fromDate.day))
          ) === 1) ||
        isAfterExtensionDate(availabilityArrayPayload[i].date, extensionToDate)
      ) {
        day.parentElement.setAttribute('disabled', 'date-disabled');
        addClass('date-disabled', day);
        return defaultOutputValue;
      } else {
        // return '<span>'+ value +'</span><span class="calendar__month-week-date-price ngb-dp-price">€ '+ availabilityArrayPayload[i].offer.price +'</span>' // TODO uncommit later with price
        return defaultOutputValue;
      }
    }
  }
}
